import * as Sentry from "@sentry/react";
import { useQuery } from "react-query";

import axios from "axios";

import { GEO_MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { MapLayer } from "../models/mapLayer";

const API_URL = `${GEO_MAP_SERVICE_ADDRESS}/map-layer`;

export const GEO_MAP_LAYERS_QUERY_KEYS = {
  geoMapLayers: "geoMapLayers"
};

const getGeoMapLayers = async () => {
  if (!GEO_MAP_SERVICE_ADDRESS) {
    const { logger } = Sentry;
    logger.warn(
      "GEO_MAP_SERVICE_ADDRESS is not defined. Please set REACT_APP_GEO_MAP_SERVICE in your environment variables."
    );
    return [];
  }

  try {
    const response = await axios.get(API_URL);
    return response.data.map((layer) => {
      layer.maps = layer.maps.filter((map) => {
        return (map.Calculation ?? map.Raster)?.deleted == null;
      });
      return layer;
    });
  } catch (error) {
    // If the request fails, return an empty array
    return [];
  }
};

const useGeoMapLayers = () => {
  return useQuery<MapLayer[]>(GEO_MAP_LAYERS_QUERY_KEYS.geoMapLayers, getGeoMapLayers);
};

export default useGeoMapLayers;
